import { statusClickup } from "../types/initStore/initProject";
import { teamAreasByFormProject, teamAreasByFormValue } from "../types/initStore/initUser";
import { statusProjectType } from "../types/statusProject";
import { changeMillisecondsToDecimal } from "./changeHours";
import { changeDateTimeZone } from "./dayjsHelper";
import { differenceNumbers, percentageNumber } from "./operationMath";
import { trimSpaces } from "./textTransform";

export const whatAreaIs = (area = "") => {
	let nameJson = "";
	let nameArea = trimSpaces(area);
	if (nameArea === trimSpaces(teamAreasByFormProject.planning)) {
		nameJson = "planning";
	}
	if (nameArea === trimSpaces(teamAreasByFormProject.desing)) {
		nameJson = "design";
	}
	if (nameArea === trimSpaces(teamAreasByFormProject.web)) {
		nameJson = "web";
	}
	if (nameArea === trimSpaces(teamAreasByFormProject.unity)) {
		nameJson = "unity";
	}
	if (nameArea === trimSpaces(teamAreasByFormProject.art3d)) {
		nameJson = "art3d";
	}

	return { nameJson };
};

export const whatAreaIsConclued = (area = "") => {
	let nameValue = "";
	let nameArea = trimSpaces(area);
	if (nameArea === teamAreasByFormValue.desing) {
		nameValue = teamAreasByFormProject.desing;
	}
	if (nameArea === teamAreasByFormValue.art3d) {
		nameValue = teamAreasByFormProject.art3d;
	}
	if (nameArea === teamAreasByFormValue.planning) {
		nameValue = teamAreasByFormProject.planning;
	}
	if (nameArea === teamAreasByFormValue.unity) {
		nameValue = teamAreasByFormProject.unity;
	}
	if (nameArea === teamAreasByFormValue.web) {
		nameValue = teamAreasByFormProject.web;
	}
	return { nameValue };
};

const whatSaveHours = (status, hour, estimate) => {
	let selectHour = 0;
	if (
		status === statusClickup.pendiente ||
		status === statusClickup.proceso ||
		status === statusClickup.test ||
		status === statusClickup.diferido
	) {
		selectHour = estimate < hour ? hour : estimate;
	}
	if (status === statusClickup.cancelado) {
		selectHour = hour;
	}
	if (status === statusClickup.complete) {
		selectHour = hour;
	}
	return selectHour;
};

export const entriesSumTask = (entries = [], nameProject = "") => {
	let sumTimeTracket = 0;
	let sumByArea = {
		web: { estimate: 0, selectHours: 0, hours: 0 },
		art3d: { estimate: 0, selectHours: 0, hours: 0 },
		unity: { estimate: 0, selectHours: 0, hours: 0 },
		design: { estimate: 0, selectHours: 0, hours: 0 },
		planning: { estimate: 0, selectHours: 0, hours: 0 },
	};

	entries.forEach((entrie) => {
		if (entrie) {
			const {
				time_spent,
				time_estimate,
				// name,
				status: { status: nameStatus },
				list: { name: listName },
			} = entrie;
			let timeTracket = 0;
			let timeEstimate = 0;
			if (time_spent !== undefined) {
				timeTracket = parseInt(time_spent);
			}
			if (time_estimate) {
				timeEstimate = parseInt(time_estimate);
			}
			const hoursWork = changeMillisecondsToDecimal(timeTracket);
			const hoursEstimate = changeMillisecondsToDecimal(timeEstimate);
			sumTimeTracket += parseFloat(hoursWork.toFixed(2));
			const selectHours = whatSaveHours(nameStatus, hoursWork, hoursEstimate);
			const { nameJson } = whatAreaIs(listName);
			if (nameJson !== "") {
				sumByArea[nameJson].hours += hoursWork;
				sumByArea[nameJson].estimate += hoursEstimate;
				sumByArea[nameJson].selectHours += selectHours;
			} else {
				console.log("error entries", nameJson, entrie);
			}
		}
	});
	return {
		sumTimeTracket,
		countTask: entries.length,
		sumByArea,
	};
};

export const sumExtraResource = (hoursExtraResource = []) => {
	let sumTotalExtraResource = 0;
	let sumByArea = {
		web: { hours: 0 },
		art3d: { hours: 0 },
		unity: { hours: 0 },
		design: { hours: 0 },
		planning: { hours: 0 },
	};
	let tableExtraResource = [];
	hoursExtraResource.forEach((hrsResource) => {
		const { hours, area, doesHaveImpact } = hrsResource;
		const { nameJson } = whatAreaIs(area);
		if (nameJson !== "" && doesHaveImpact) {
			sumTotalExtraResource += hours;
			sumByArea[nameJson].hours += hours;
		}

		let dates = {
			start: "",
			end: "",
		};
		let commentCopy = "";
		if (hrsResource.comment) {
			commentCopy = hrsResource.comment.text;
		}
		if (hrsResource.dates) {
			dates.start = hrsResource.dates.started === undefined ? "" : hrsResource.dates.started;
			dates.end = hrsResource.dates.finished === undefined ? "" : hrsResource.dates.finished;
		}

		tableExtraResource.push({
			key: hrsResource._id,
			doesHaveImpact: hrsResource.doesHaveImpact,
			area: hrsResource.area,
			extraresources: hrsResource.name,
			typeextraresources: hrsResource.type,
			amount: hrsResource.amount,
			currency: hrsResource.currency,
			hours: hrsResource.hours,
			dateStart: dates.start,
			dateFinished: dates.end,
			comment: commentCopy,
		});
	});
	return {
		sumTotalExtraResource,
		sumByArea,
		tableExtraResource,
	};
};

export const sumHoursExtra = (extraTime = []) => {
	let sumTotalHoursExtra = 0;
	let sumByArea = {
		web: { hours: 0 },
		art3d: { hours: 0 },
		unity: { hours: 0 },
		design: { hours: 0 },
		planning: { hours: 0 },
	};
	let tableExtraTime = [];
	extraTime.forEach((hrsExtra) => {
		const {
			hours,
			area,
			_id,
			user: { name: nameUser },
		} = hrsExtra;
		const { nameJson } = whatAreaIs(area);
		if (nameJson !== "") {
			sumTotalHoursExtra += hours;
			sumByArea[nameJson].hours += hours;
		} else {
			console.log("error extra time", hrsExtra);
		}
		tableExtraTime.push({ key: _id, developer: nameUser, ...hrsExtra });
	});
	return {
		sumTotalHoursExtra,
		sumByArea,
		tableExtraTime,
	};
};

export const tasksConcluedForEntrys = (tasks = {}) => {
	const newTasks = [];
	for (const key in tasks) {
		if (Object.hasOwnProperty.call(tasks, key)) {
			const element = tasks[key];
			const getTask = element.map(({ time, taskName, timeEstimate, taskStatus, ...rest }) => {
				const { nameValue } = whatAreaIsConclued(key);
				return {
					...rest,
					time_spent: time,
					time_estimate: timeEstimate,
					name: taskName,
					status: { status: taskStatus },
					list: { name: nameValue },
				};
			});
			newTasks.push(getTask);
		}
	}
	const flattenedArray = [].concat(...newTasks);
	return flattenedArray;
};

export const getTableProjects = (projects = []) => {
	let allDateStart = [];
	const filterProject = projects.filter((project) => project);
	const tableProject = filterProject.map((project) => {
		const {
			_idProject,
			name,
			tasks,
			extraResources,
			calculatedHours: {
				planning,
				development: { total: developmentTotal },
			},
			countTasks,
			teamAdmin: { leaders, peopleInChargeProject, peopleInCharge },
			startedDate,
			hasComments,
			status,
			clickupSpace,
			extraTime,
			tasksArea,
		} = project;
		let tasksProject = tasks;
		if (status === statusProjectType.concluid) {
			tasksProject = tasksConcluedForEntrys(tasksArea);
		}
		//* Team
		const newLeaders = leaders.map((data) => data.name);
		const comercial = peopleInChargeProject.map((data) => data.name);
		const responsable = peopleInCharge.map((data) => data.name);
		//* Sum
		const { sumTimeTracket } = entriesSumTask(tasksProject, name);
		const { sumTotalExtraResource } = sumExtraResource(extraResources);
		const { sumTotalHoursExtra } = sumHoursExtra(extraTime);
		const sumTotal = sumTimeTracket + sumTotalExtraResource + sumTotalHoursExtra;

		let budget = developmentTotal + planning;
		let consume = 0;

		let difference = differenceNumbers(sumTotal, budget);
		difference = parseFloat(difference.toFixed(2));

		if (sumTotal > 0) {
			consume = percentageNumber(budget, sumTotal);
			consume = parseInt(consume);
		}

		const { day } = changeDateTimeZone(startedDate);
		let dateStart = day.format("YYYY");

		if (!allDateStart.includes(dateStart)) {
			allDateStart.push(dateStart);
		}
		return {
			key: clickupSpace,
			name,
			status,
			leader: newLeaders,
			responsible: responsable,
			comercial,
			hoursdevelop: budget,
			hrsWork: sumTotal,
			difference: difference,
			consume: consume,
			startDate: dateStart,
			clickupSpace,
			hasComments,
			countEntries: tasksProject.length,
			countTasks,
			_idProject,
		};
	});
	return { tableProject, allDateStart };
};
